import register from '../register';
import PlacesAutoComplete from './classes/places-autocomplete';

const $ = document.querySelector.bind( document );

function sendAddressToDom( res ) {
  let fields = [
    'street_number',
    'street',
    'neighborhood',
    'borough',
    'city',
    'state',
    'country',
    'postal_code',
    'lat',
    'lng',
    'gis_id',
    'place_id',
    'in_market'
  ];

  fields.forEach( field => {
    const input = $( `input[name=${ field }]` );
    input.value = res[ field ] ? res[ field ] : '';
  });
}

function setFlow( flow ) {
  const input = $('input[name="flow"]');
  input.value = flow;
}

class ServiceableAutoComplete extends PlacesAutoComplete {
  onSelect( place ) {
    this._trackSelection( place, ( err, res ) => {
      res = res || {};
      console.log( res );

      if ( place.suggestion ) {
        // eslint-disable-next-line max-len
        { this.input.value = `${ place.suggestion.name }, ${ place.suggestion.locality }, ${ place.suggestion.state } ${ place.suggestion.postal_code }`; }
      }

      switch ( res.flow ) {
        case 'serviceable':
          console.log('serviceable');
          sendAddressToDom( res );
          setFlow( res.flow );
          break;
        case 'signup':
          console.log('signup');
          sendAddressToDom( res );
          setFlow( res.flow );
          break;
        case 'waitlist':
        case 'paused':
          setFlow( res.flow );
          sendAddressToDom( res );
          console.log('waitlist');
          break;
        case 'unknown':
          setFlow( res.flow );
          sendAddressToDom( res );
          window.location.href = `${ window.signup_url }/register`;
          console.log('unknown');
        default:
          setFlow( res.flow );
          sendAddressToDom( res );
          console.log('not serviceable');
      }
    });
  }
}

register( 'check-avail-petition', () => {
  const component = document.querySelector('.check-avail-petition-component');
  const input = component.querySelector('#check-availability-input');
  const list = component.querySelector('.results');
  const hooks = {
    input() {
      component.classList.remove('required-error');
    }
  };
  new ServiceableAutoComplete({ input, list, hooks });
});

export default undefined;
